import { useEffect, useState } from 'react'
import NumberField from '../Reusable/Form/NumberField';
import Select, { } from 'react-select'
import makeAnimated from 'react-select/animated';

const animatedComponents = makeAnimated();

const ReturnRateForm = (props: any) => {
  const { register, errors, statusList, setValue, watch, getValues, clearErrors } = props
  const [defaultValue, setDefaultValue] = useState()

  const onChange = (value: any) => {
    setValue("return_status", value)
    setDefaultValue(value)
  };

  useEffect(() => {
    if (!defaultValue) {
      setDefaultValue(watch("return_status"))
    }
  }, [watch("return_status")])

  return (
    <>
      <div>
        <p className='text-primary my-4'>Note: <span className='text-black'>Choose Return to Vendor status for Return Charge</span></p>
      </div>
      <div className='w-full grid grid-cols-2 gap-4'>
        <div className='mt-3'>
          <label htmlFor="" className='block mb-2'>Return Status</label>
          <Select
            value={defaultValue}
            components={animatedComponents}
            closeMenuOnSelect={false}
            options={statusList}
            onChange={onChange}
            isMulti
          />
          {errors?.return_status && (
            <p className="text-red-500 text-xs my-1">{errors?.return_status?.message}</p>
          )}
        </div>
        <div>
          <NumberField
            setValue={setValue}
            clearErrors={clearErrors}
            label={"Amount"}
            register={register("amount")}
            errors={errors?.amount}
            value={getValues()["amount"]}
          />
        </div>
      </div>

    </>
  )
}

export default ReturnRateForm
